/**
 * Where the dashboard's Send Message action sends an external user (customer or supplier).
 *
 * PGSS-5441. The rule used to be "add an s to the stage name", with a handful of exceptions listed
 * afterwards. That works only where the stage happens to pluralise into a route that exists:
 *
 *   order -> orders        route exists
 *   fulfilled -> fulfilleds   NO SUCH ROUTE -> 404
 *   in-production -> in-productions   NO SUCH ROUTE -> 404
 *
 * so Send Message on the dashboard's Shipped Orders and In Production panels opened the 404 page.
 * It is the same dead end PGSS-5411 reported on the Shipped Orders *list*; that fix added the
 * fulfilled/:orderId route, which the list reaches because it does not pluralise. The dashboard
 * keeps its own copy of this logic and still built the wrong address.
 *
 * Extracted as a pure function so the mapping is testable without mounting a dashboard widget.
 * A stage MUST map to a route that exists in the app configs -- a default that guesses is what
 * caused this.
 */
const EXTERNAL_ROUTES = {
  rfd: { title: 'Rfp', redirectionType: 'rfds' },
  completed: { title: 'Rfp Completed', redirectionType: 'completed' },
  confirmed: { title: 'Confirmed Order', redirectionType: 'confirmed' },
  fulfilled: { title: 'Shipped Order', redirectionType: 'fulfilled' },
  // No in-production/:orderId route exists; these rows are orders, and orders/:orderId does.
  'in-production': { title: 'Order', redirectionType: 'orders' },
  rfq: { title: '', redirectionType: 'rfqs' },
};

/** Routes this mapping is allowed to produce. Anything else is a 404 waiting to happen. */
export const KNOWN_NOTE_ROUTES = [
  'orders', 'rfds', 'completed', 'confirmed', 'fulfilled', 'rfqs', 'quotes', 'awaiting-approval',
];

export const getNoteRedirect = (stage, isCustomerRole) => {
  if (stage === 'order') {
    return { title: isCustomerRole ? 'Orders' : 'Received Order', redirectionType: 'orders' };
  }
  const mapped = EXTERNAL_ROUTES[stage];
  if (mapped) return mapped;
  // Unmapped stage: fall back to the old pluralisation rather than change behaviour for a stage
  // nobody has reported. Listed here so the next 404 of this shape is one lookup away.
  return { title: '', redirectionType: `${stage}s` };
};
